import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompass = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16 4a12 12 0 1 0 0 24 12 12 0 1 0 0-24ZM22.5 9.5 18.4 18.4 9.5 22.5l4.1-8.9L22.5 9.5Z",
				stroke: "white",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 5.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16 4a12 12 0 1 0 0 24 12 12 0 1 0 0-24Z",
				style: { fill: "var(--sticker-pastel,#D0DBFF)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.5 9.5 18.4 18.4 9.5 22.5l4.1-8.9L22.5 9.5Z",
				style: { fill: "var(--sticker-accent,#657198)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16 14.6a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 1 0 0-2.8Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16 4a12 12 0 1 0 0 24 12 12 0 1 0 0-24ZM22.5 9.5 18.4 18.4 9.5 22.5l4.1-8.9L22.5 9.5Z",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				style: { stroke: "var(--sticker-dark,#505772)" }
			})
		]
	});
};
export default SvgCompass;
